import React from "react";
import classNames from "classnames";

// onClick={ (e) => {
//   e.stopPropagation()
//   props.onSelect()
// }}
export default props => (
  <div
    style={{ position: "absolute", top: -1, left: -1, bottom: -1, right: -1, ...props.style }}
    className={classNames({
      "block-selected": props.selected,
      selectable: !props.isCanvas && props.showOutline
    })}>
    {props.children}
  </div>
);



// WEBPACK FOOTER //
// ./src/canvas/enhancers/selectable.js